import {
  PagedResultOfTrainingAndStandardisationReportRecordDto,
  api,
  TrainingAndStandardisationReportRecordDto,
} from 'api';
import { TableState } from 'types';
import { rtkQueryApi } from 'store/rtkQueryApi';
import {
  getPaginationParameters,
  getQueryStringParameters,
  getBcCentresIds,
  getCentresIds,
} from 'utils';
import { TrainingAndStandardisationFilterType } from './trainingAndStandardisationReportTypes';
import { Timestamp } from '@britishcouncil/common-core';

type ReportParams = TableState<
  TrainingAndStandardisationReportRecordDto,
  TrainingAndStandardisationFilterType
>;

const mapQueryParams = (params: ReportParams) => {
  return getQueryStringParameters({
    ...getPaginationParameters(params),
    filter: {
      ...params.filters,
      from: params.filters.date?.[0] ? Timestamp.toISOString(params.filters.date[0]) : undefined,
      to: params.filters.date?.[1] ? Timestamp.toISOString(params.filters.date[1]) : undefined,
      organisingCentreIds: getBcCentresIds(params.filters.organisingCentreIds),
      mainSpeakingCentreIds: getCentresIds(params.filters.mainSpeakingCentreIds),
      mainWritingCentreIds: getCentresIds(params.filters.mainWritingCentreIds),
    },
  });
};

export const trainingAndStandardisationReportApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getTrainingAndStandardisationReportRecords: builder.query<
      PagedResultOfTrainingAndStandardisationReportRecordDto,
      ReportParams
    >({
      query: (params) => {
        const input = mapQueryParams(params);
        return api.trainingAndStandardisationReport.getTrainingsAndStandardisations(input);
      },
    }),
    generateTrainingAndStandardisationPdfReport: builder.mutation<File, ReportParams>({
      query: async (params) => {
        const input = mapQueryParams(params);
        return api.trainingAndStandardisationReport.getTrainingsAndStandardisationsPdfReport(
          input,
          { format: 'arraybuffer' }
        );
      },
    }),
    generateTrainingAndStandardisationExcelReport: builder.mutation<File, ReportParams>({
      query: async (params) => {
        const input = mapQueryParams(params);
        return api.trainingAndStandardisationReport.getTrainingsAndStandardisationsExcelReport(
          input,
          { format: 'arraybuffer' }
        );
      },
    }),
  }),
});

export const {
  useGetTrainingAndStandardisationReportRecordsQuery,
  useGenerateTrainingAndStandardisationPdfReportMutation,
  useGenerateTrainingAndStandardisationExcelReportMutation,
} = trainingAndStandardisationReportApi;
